import { useTranslation } from 'react-i18next'

import { useTimeZone } from '../../../../../../../hooks'
import { FloatingTooltipContentText } from '../../../../../../Floating'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../../../../../Icon'
import { TableCellEmpty } from '../../../../../../Table'
import Text from '../../../../../../Text'
import { getApplicantDocumentVerdictMeta } from '../../ApplicantDocumentChecklist.utils'

import * as styles from './ApplicantDocumentChecklistAuditCell.module.css'

import InformationIcon from '../../../../../../../icons/info.svg'

function ApplicantDocumentChecklistAuditCell({ row }) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const meta = getApplicantDocumentVerdictMeta({ row, t, timezone })

  const hasReasonOnly = Boolean(meta) && !meta.tooltip

  return (
    <div className={styles.ApplicantDocumentChecklistAuditCell}>
      {meta?.tooltip ? (
        <>
          <Text isSecondary className={styles.meta}>
            {meta.date}
          </Text>
          <IconWithTooltip
            Icon={InformationIcon}
            size={ICON_HEIGHT_16}
            svgSize={ICON_HEIGHT_16}
            tooltip={
              <FloatingTooltipContentText
                additionalText={meta.reason}
                text={meta.tooltip}
              />
            }
          />
        </>
      ) : null}
      {hasReasonOnly ? (
        <Text isSecondary className={styles.meta}>
          {meta.reason}
        </Text>
      ) : null}
      {meta ? null : <TableCellEmpty />}
    </div>
  )
}

export default ApplicantDocumentChecklistAuditCell
